import './BackwardStatusWarningModal.scss'

import React from 'react'
import { connectModal } from 'redux-modal'
import { Button, Modal } from 'react-bootstrap'


const BackwardStatusWarning = ({
  handleHide,
  show,
  onConfirm,
}) => {
  const onContinue = () => {
    handleHide()
    onConfirm()
  }

  return (
    <Modal className="BackwardStatusWarningModal" show={show}>
      <Modal.Body>
        <div className="BackwardStatusWarningModal__paragraph--strong">
            Are you sure you want to continue?
        </div>
        <div className="BackwardStatusWarningModal__paragraph">
            We do not recommend moving a status backward unless you are correcting a mistake.
        </div>
        <div className="BackwardStatusWarningModal__action_buttons">
          <Button className="BackwardStatusWarningModal__button BackwardStatusWarningModal__button--continue" onClick={onContinue} bsStyle="info">Continue</Button>
          <Button className="BackwardStatusWarningModal__button" onClick={handleHide} bsStyle="info">Cancel</Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

const withModalHandlers = connectModal({ name: 'BackwardStatusWarningModal' })

export const BackwardStatusWarningModal = withModalHandlers(BackwardStatusWarning)
